module.exports = __webpack_public_path__ + "img/MOV.7ede8353.png";